import * as React from "react";
import { useId } from "react-id-generator";
import classNames from "classnames";
import { LinkButton } from "../atoms/link-button";
import { SecondaryButton } from "@graffer-inc/console-design-kit";

type DropdownProps = {
  title?: string;
  isActive: boolean;
  isRight?: boolean;
  onClick: () => void;
  menus: Array<
    | {
        title: string;
        onClick: () => void;
        disable?: boolean;
      }
    | false
  >;
  disabled?: boolean;
};

export const Dropdown: React.FC<DropdownProps> = ({
  title,
  isActive,
  isRight,
  onClick,
  menus,
  disabled,
}) => {
  const [dropdownMenuId] = useId();
  return (
    <div
      className={classNames("dropdown", {
        "is-active": isActive,
        "is-right": isRight,
      })}
    >
      <div className="dropdown-trigger">
        {title ? (
          <SecondaryButton
            text={title}
            aria-haspopup="true"
            aria-controls={dropdownMenuId}
            disabled={disabled}
            onClick={onClick}
            icon="ArrowDownIcon"
            iconPosition="right"
          />
        ) : (
          <button
            className="button"
            aria-haspopup="true"
            aria-controls={dropdownMenuId}
            disabled={disabled}
            onClick={onClick}
            data-for-rpa-id={"toggle-menu"}
          >
            <span className="icon is-small">
              <i className="fas fa-ellipsis-v" />
            </span>
          </button>
        )}
      </div>
      <div
        className="dropdown-menu has-text-left"
        id={dropdownMenuId}
        role="menu"
      >
        <div className="dropdown-content">
          {menus.map((m, index) => {
            if (!m) {
              return null;
            }
            return (
              <React.Fragment key={m.title + index}>
                {index > 0 && <hr className="dropdown-divider" />}
                {!m.disable ? (
                  <LinkButton
                    className="dropdown-item"
                    aria-disabled={m.disable}
                    style={{ display: "block", padding: "15px 10px" }}
                    onClick={(e: any) => {
                      e.stopPropagation();
                      m.onClick();
                    }}
                    data-for-rpa-id={m.title}
                  >
                    {m.title}
                  </LinkButton>
                ) : (
                  // LinkButton cannot be disabled by html tag, thus use div tag to disable menu item
                  <div
                    className="dropdown-item"
                    style={{
                      color: "gray",
                      padding: "15px 10px",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {m.title}
                  </div>
                )}
              </React.Fragment>
            );
          })}
        </div>
      </div>
    </div>
  );
};
